<template>
  <div class="inner-tab-wrapper mb-4">
    <b-overlay center :show="isLoading" rounded="sm">
      <div v-if="!isLoading">
        <div data-type="book-entry-general">
          <!--Dati Generali, Dati di Polizza, Dati anagrafici, Premio, Provv. Agenzia, Provv. Coll., Importi Documenti su Polizza -->
          <details-card
            v-for="(item, index) in detailFields"
            :key="index"
            :title="index"
            :header="item.header"
            :edit="item.edit || false"
            :fields="item.fields"
            :beForm="beForm"
            :data="details"
            :repository="item.repository"
            @modal="onOpenDetailsModal"
          >
          </details-card>

          <!-- Forme di Pagamento -->
          <div class="form-card-wrapper" data-title="forme_di_pagamento">
            <b-card
              header="true"
              header-tag="header"
              v-if="checkTreasuryRelation.length"
            >
              <div
                slot="header"
                class="d-flex justify-content-between align-items-center"
              >
                <b>Forme di Pagamento</b>
              </div>
              <!--              <b-card-text>-->
              <!--                <b-table-->
              <!--                  class="table-sm mb-0"-->
              <!--                  striped-->
              <!--                  hover-->
              <!--                  :items="entryDetails"-->
              <!--                  :fields="entryDetailFields"-->
              <!--                >-->
              <!--                  <template v-slot:cell(treasury_code)="row">-->
              <!--                    {{ row.item?.treasury?.code }}-->
              <!--                  </template>-->
              <!--                  <template v-slot:cell(treasury_title)="row">-->
              <!--                    <b-card-text>-->
              <!--                      <span>{{ row.item?.treasury?.title }}</span>-->
              <!--                      <span-->
              <!--                        v-if="row.item?.treasury?.code === 'SS'"-->
              <!--                        :class="-->
              <!--                          deferredStatus(row.item) ===-->
              <!--                          'Completamente recuperato'-->
              <!--                            ? 'badge-closed'-->
              <!--                            : deferredStatus(row.item) ===-->
              <!--                              'Parzialmente recuperato'-->
              <!--                            ? 'badge-partially-closed'-->
              <!--                            : deferredStatus(row.item) ===-->
              <!--                              'Totalmente da recuperare'-->
              <!--                            ? 'badge-open'-->
              <!--                            : ''-->
              <!--                        "-->
              <!--                        >{{ deferredStatus(row.item) }}-->
              <!--                      </span>-->
              <!--                    </b-card-text>-->
              <!--                  </template>-->
              <!--                  <template v-slot:cell(amount)="row">-->
              <!--                    {{ toLocaleCurrency(row.item.gross) }}-->
              <!--                  </template>-->
              <!--                </b-table>-->
              <!--              </b-card-text>-->
              <b-card-text>
                <b-table
                  striped
                  hover
                  :items="myEntryDetails"
                  :fields="entryDetailFields"
                >
                  <!-- <template v-slot:cell(treasury_code)="row">
                    {{ row.item?.treasury?.code }}
                  </template> -->
                  <template v-slot:cell(treasury_title)="row">
                    <b-card-text>
                      <span
                        v-if="row.item?.linkType === 'child'"
                        :class="{ 'child-row': row.item?.linkType === 'child' }"
                        >↪&nbsp;</span
                      >
                      <span
                        >{{ row.item?.treasury?.display }} -
                        {{ row.item?.treasury?.title }}</span
                      >
                      <span
                        v-if="row.item?.treasury?.code === 'SS'"
                        :class="
                          deferredStatus(row.item) ===
                          'Completamente recuperato'
                            ? 'badge-closed'
                            : deferredStatus(row.item) ===
                              'Parzialmente recuperato'
                            ? 'badge-partially-closed'
                            : deferredStatus(row.item) ===
                              'Totalmente da recuperare'
                            ? 'badge-open'
                            : ''
                        "
                        >{{ deferredStatus(row.item) }}
                      </span>
                      <span
                        v-else-if="row.item?.treasury?.code === 'AC'"
                        :class="
                          depositedStatus(row.item) ===
                          'Completamente recuperato'
                            ? 'badge-closed'
                            : depositedStatus(row.item) ===
                              'Parzialmente recuperato'
                            ? 'badge-partially-closed'
                            : depositedStatus(row.item) ===
                              'Totalmente da recuperare'
                            ? 'badge-open'
                            : ''
                        "
                        >{{ depositedStatus(row.item) }}
                      </span>
                    </b-card-text>
                  </template>
                  <template v-slot:cell(date)="row">
                    <span
                      v-if="row.item?.linkType === 'child'"
                      :class="{ 'child-row': row.item?.linkType === 'child' }"
                      >↪&nbsp;</span
                    >{{ toLocaleDate(row.item.detail_date) }}
                  </template>
                  <template v-slot:cell(amount)="row">
                    <span
                      v-if="row.item?.linkType === 'child'"
                      :class="{ 'child-row': row.item?.linkType === 'child' }"
                      >↪&nbsp;</span
                    >{{ toLocaleCurrency(row.item.gross) }}
                  </template>
                </b-table>
              </b-card-text>
            </b-card>
          </div>
          <!-- COASSICURAZIONI, COASSICURAZIONI DETTAGLIO -->
          <template v-if="isDelegaNostra">
            <details-card
              v-for="(item, index) in coassFields"
              :key="index"
              :title="index"
              :header="item.header"
              :edit="item.edit || false"
              :fields="item.fields"
              :beForm="beForm"
              :data="details"
              :repository="item.repository"
            >
            </details-card>
          </template>
          <div
            class="form-card-wrapper"
            style="margin-top: 0"
            data-title="coass_detail"
          >
            <b-card
              header="true"
              header-tag="header"
              v-if="coassDetails.length && isDelegaNostra"
            >
              <div
                slot="header"
                class="d-flex justify-content-between align-items-center"
              >
                <b>Dettaglio Coassicurazioni</b>
              </div>
              <b-card-text>
                <b-table
                  striped
                  hover
                  :items="coassDetails"
                  :fields="coassDetailFields"
                  responsive
                >
                  <!-- compagnia_delegata: code_importer - title_importer
                agenzia_delegata: code
                quote_attribuite: pivot.share -->
                  <!-- { key: "compagnia_delegata", label: "Codice Compagnia" },
                { key: "agenzia_delegata", label: "Codice Agenzia" },
                { key: "descrizione", label: "Codice Agenzia" },
                { key: "participant_prov_purchase", label: "Provv.Acq.Agente" },
                { key: "participant_prov_take", label: "Provv.Inc.Agente" },
                { key: "net", label: "Imponibile" },
                { key: "tax", label: "Imposte" },
                { key: "gross", label: "Totale" }, -->
                  <template v-slot:cell(compagnia_delegata)="row">
                    {{ row.item.code_importer }} - {{ row.item.title_importer }}
                  </template>
                  <template v-slot:cell(agenzia_delegata)="row">
                    {{ row.item.code }}
                  </template>
                  <template v-slot:cell(descrizione)="row">
                    {{ row.item.title }}
                  </template>
                  <!-- <template v-slot:cell(quote_attribuite)="row">
                  {{ row.item.pivot.share }}%
                </template> -->
                  <template v-slot:cell(participant_prov_purchase)="row">
                    {{
                      toLocaleCurrency(row.item.pivot.participant_prov_purchase)
                    }}
                  </template>
                  <template v-slot:cell(participant_prov_take)="row">
                    {{ toLocaleCurrency(row.item.pivot.participant_prov_take) }}
                  </template>
                  <template v-slot:cell(net)="row">
                    {{ toLocaleCurrency(row.item.pivot.net) }}
                  </template>
                  <template v-slot:cell(tax)="row">
                    {{ toLocaleCurrency(row.item.pivot.tax) }}
                  </template>
                  <template v-slot:cell(gross)="row">
                    {{ toLocaleCurrency(row.item.pivot.gross) }}
                  </template>
                </b-table>
              </b-card-text>
            </b-card>
          </div>
        </div>
      </div>
      <template #overlay>
        <div class="text-center">
          <div class="custom-loader"></div>
          <!-- <base-icon name="loading" width="35" height="35" /> -->
          <p class="loading-text">Operazione in corso...</p>
        </div>
      </template>
      <b-modal
        id="modalPolicy"
        @modal="onOpenDetailsModal"
        @show="onModalShow"
        @hidden="onModalHidden"
        :title="computeModalTitle"
        size="xl"
        scrollable
        ok-only
        ok-variant="lisaweb"
        header-bg-variant="lisaweb"
        no-close-on-backdrop
      >
        <div>
          <b-tabs content-class="pt-1" lazy v-model="tabIndex">
            <b-tab
              v-for="(tab, index) in tabs"
              :key="index"
              @click="setTab(tab, index)"
              :title="tab.text"
              :active="index === tabIndex"
              title-item-class="lisaweb"
            >
              <button-group-tab> </button-group-tab>
              <keep-alive>
                <component
                  v-if="selected === tab.name"
                  :is="selected"
                  :resourceId="modalResourceId"
                  :dbRowData="dbRowData"
                  @fetch="fetch"
                ></component>
              </keep-alive>
            </b-tab>
          </b-tabs>
        </div>
      </b-modal>
    </b-overlay>
  </div>
</template>

<script>
import ShowMixin from "@/mixins/ShowMixin";
import FormMixin from "@/mixins/FormMixin";
import DetailsCard from "@/components/DetailsCard";
import { toLocaleCurrency } from "@/utils/strings";
import { toInfoData } from "@/utils/transforms";
import { toLocaleDate } from "@/utils/dates";
import moment from "moment";
import ButtonGroupTab from "../../../ButtonGroupTab.vue";
import General from "@/components/wallet/policies/details/General";
import TechnicalData from "@/components/wallet/policies/details/TechnicalData";
import Registry from "@/components/wallet/policies/details/Registry";
import Group from "@/components/wallet/policies/details/Group";
import Titles from "@/components/wallet/policies/details/Titles";
import Accident from "@/components/wallet/policies/details/Claims";
import Notes from "@/components/wallet/policies/details/Notes";
import Todo from "@/components/wallet/policies/details/Todo";
import Accounting from "@/components/wallet/policies/details/Accounting";
import Appointments from "@/components/wallet/policies/details/Appointments";
import Documents from "@/components/wallet/policies/details/Documents";
import Sepa from "@/components/wallet/policies/details/Sepa";

moment.locale("it");

export default {
  mixins: [ShowMixin, FormMixin],
  name: "GeneralBookEntries",
  props: {
    resourceId: Number,
  },
  components: {
    ButtonGroupTab,
    DetailsCard,
    General,
    TechnicalData,
    Registry,
    Group,
    Titles,
    Accident,
    Notes,
    Accounting,
    Documents,
    Appointments,
    Todo,
    Sepa,
  },
  data() {
    return {
      details: null,
      repository: "book_entry",
      selected: "General",
      modalResourceId: null,
      modalResourceTitle: null,
      tabIndex: 0,
      tabs: [
        { name: General, text: "Generale" },
        { name: "TechnicalData", text: "Dati tec." },
        { name: "Registry", text: "Contraente" },
        { name: "Titles", text: "Titoli" },
        { name: "Accounting", text: "Incassi" },
        { name: "Accident", text: "Sinistri" },
        { name: "Appointments", text: "Appuntamenti" },
        { name: "Notes", text: "Note" },
        { name: "Todo", text: "Attività" },
        { name: "Group", text: "Gruppi" },
        { name: "Documents", text: "Doc" },
        { name: "Sepa", text: "Sepa" },
      ],
      dbRowData: null,
      // Entry Details Table
      checkTreasuryRelation: [],
      entryDetailFields: [
        { key: "date", label: "Data Movimentazione Contabile" },
        { key: "treasury_title", label: "Cassa" },
        {
          key: "amount",
          label: "Importo",
          thClass: "text-right",
          tdClass: "text-right",
        },
      ],
      entryDetails: [],
      myEntryDetails: [],
      form: {
        entry_detail: {
          book_entry_id: null,
          treasury_id: null,
          gross: null,
          detail_date: null,
        },
        book_entries: {
          entry_details: {},
        },
      },
      detailFields: {
        book_entry: {
          header: "Dati Generali",
          fields: [
            {
              label: this.getDictionary("effective_date", "book_entry"),
              value: "effective_date",
              type: "datepicker",
            },
            {
              label: this.getDictionary("book_date", "book_entry"),
              value: "book_date",
              type: "datepicker",
            },
            {
              label: this.getDictionary("insurer"),
              value: "insurer.code",
            },
            {
              label: this.getDictionary("salesman"),
              value: "salesman",
              virtual: (detail) => {
                return this.toInfoData(
                  detail.brokers[0],
                  "broker",
                  0,
                  null,
                  "\n",
                );
              },
            },
            {
              label: this.getDictionary("cooperator"),
              value: "cooperator",
              virtual: (detail) => {
                const take = detail?.entry_details?.filter(
                  (entry_detail) =>
                    !["EN", "PR"].includes(entry_detail?.treasury?.code),
                );
                if (
                  !detail.insurance_ancillaries[0]?.insurance_policy
                    ?.collaborator_id
                ) {
                  return this.toInfoData(
                    detail.brokers.find((e) => e.status_broker.value === 1),
                    "broker",
                    1,
                    null,
                    "\n",
                  );
                } else {
                  return `${this.toInfoData(
                    detail.brokers.find((e) => e.status_broker.value === 1),
                    "broker",
                    1,
                    null,
                    "\n",
                  )} (${take.length ? "Diretto" : "Tramite collaboratore"})`;
                }
              },
            },
            // {
            //   label: this.getDictionary("Nr. foglio cassa"),
            //   value: "book_entry_number",
            // },
            {
              label: this.getDictionary("sheet_date", "book_entry"),
              value: "sheet_date",
              type: "datepicker",
            },
            {
              label: this.getDictionary("broker_statement"),
              value: "broker_statement",
              virtual: (detail) => {
                if (detail?.broker_statement_id && detail?.broker_statement) {
                  const extraParams = {};
                  if (detail.broker_statement.id)
                    extraParams["id"] = detail.broker_statement.id;
                  if (detail.broker_statement.from)
                    extraParams["date_from"] = toLocaleDate(
                      detail.broker_statement.from,
                    );
                  if (detail.broker_statement.to)
                    extraParams["date_to"] = toLocaleDate(
                      detail.broker_statement.to,
                    );
                  if (detail.broker_statement.created_date)
                    extraParams["created_date"] = toLocaleDate(
                      detail.broker_statement.created_date,
                    );
                  /*
                  `Rendicontato nel rendiconto n. ${
                    detail.broker_statement.id
                      ? detail.broker_statement.id
                      : "-"
                  } (dal ${
                    detail.broker_statement.from
                      ? toLocaleDate(detail.broker_statement.from)
                      : "-"
                  } al ${
                    detail.broker_statement.to
                      ? toLocaleDate(detail.broker_statement.to)
                      : "-"
                  }) emesso il ${
                    detail.broker_statement.created_date
                      ? toLocaleDate(detail.broker_statement.created_date)
                      : "-"
                  }`;
                  */
                  return this.getDictionary(
                    "broker_statement_included",
                    null,
                    "",
                    "it",
                    false,
                    extraParams,
                  );
                }
                return this.getDictionary("broker_statement_not_included");
              },
            },
            {
              label: this.getDictionary("sheet_number", "book_entry"),
              value: "sheet_number",
              type: "text",
            },
          ],
        },
        insurance_policy: {
          header: "Dati di Polizza",
          fields: [
            {
              label: this.getDictionary("number", "insurance_policy"),
              value: "number",
              virtual: "INSURANCE_POLICY_FROM_ACCOUNTING_OR_ANCILLARIES",
              relation: "various_accountings",
              isLink: (detail) => !(detail.various_accountings?.length > 0),
            },
            {
              label: this.getDictionary("code", "book_tag"),
              value: "book_tags",
              virtual: (detail) => {
                let book_tags = [];
                detail.book_tags.forEach((book_tag) =>
                  book_tags.push(`${book_tag.code}-${book_tag.title}`),
                );
                return book_tags.join(",");
              },
            },
            {
              label: this.getDictionary("risk_branch", "book_entry"),
              value: "insurance_policy_number",
              virtual: (detail) => {
                return detail.various_accountings &&
                  detail.various_accountings.length
                  ? detail.various_accountings[0].pivot.insurance_risk
                      .risk_branch.code
                  : detail.insurance_ancillaries &&
                    detail.insurance_ancillaries.length
                  ? detail.insurance_ancillaries[0].insurance_policy
                    ? detail.insurance_ancillaries[0].insurance_policy
                        .insurance_risk.risk_branch.code
                    : ""
                  : "";
              },
            },
            {
              label: this.getDictionary("insurance_risk", "book_entry"),
              value: "insurance_policy_number",
              virtual: (detail) => {
                return detail.various_accountings &&
                  detail.various_accountings.length
                  ? detail.various_accountings[0].pivot.insurance_risk.code
                  : detail.insurance_ancillaries &&
                    detail.insurance_ancillaries.length
                  ? detail.insurance_ancillaries[0].insurance_policy
                    ? detail.insurance_ancillaries[0].insurance_policy
                        .insurance_risk.code
                    : ""
                  : "";
              },
            },
            {
              label: this.getDictionary("Codice compagnia Delegataria"),
              value: "insurer_coass",
            },
            {
              label: this.getDictionary("Nr. appendice"),
              value: "appendix",
            },
          ],
        },
        registry: {
          header: "Dati Anagrafici",
          fields: [
            {
              label: this.getDictionary("registry", "book_entry"),
              value: "registry",
              virtual: (detail) => {
                return detail.registries.length
                  ? detail.registries[0].status_registry.value === 0
                    ? `${detail.registries[0].attributables.SURN} ${detail.registries[0].attributables.NAME}`
                    : `${detail.registries[0].attributables.CNAM}`
                  : "";
              },
            },
            {
              label: this.getDictionary("attribute_NINO_value", "registry"),
              value: "registry",
              virtual: (detail) => {
                return detail.registries.length
                  ? detail.registries[0].status_registry.value === 0
                    ? detail.registries[0].attributables.NINO
                    : ""
                  : "";
              },
            },
            {
              label: this.getDictionary("attribute_CREG_value", "registry"),
              value: "registry",
              virtual: (detail) => {
                return detail.registries.length
                  ? detail.registries[0].status_registry.value === 1
                    ? detail.registries[0].attributables.CREG
                    : ""
                  : "";
              },
            },
          ],
        },
        book_entry_premium: {
          header: "Premio",
          repository: "book_entry",
          fields: [
            {
              label: this.getDictionary("net", "book_entry"),
              value: "net",
              type: "currency",
              // value: "",
              // virtual: (detail) => {
              //   return toLocaleCurrency(
              //     detail.net -
              //       this.sumPivot(
              //         detail.insurance_ancillaries[0]?.insurer_participants,
              //         "net"
              //       )
              //   );
              // },
              // REMOVED: type: "currency",
            },
            {
              label: this.getDictionary("tax", "book_entry"),
              value: "tax",
              type: "currency",
              // value: "",
              // virtual: (detail) => {
              //   return toLocaleCurrency(
              //     detail.tax -
              //       this.sumPivot(
              //         detail.insurance_ancillaries[0]?.insurer_participants,
              //         "tax"
              //       )
              //   );
              // },
              // REMOVED: type: "currency",
            },
            {
              label: this.getDictionary("gross", "book_entry"),
              value: "gross",
              type: "currency",
              // value: "",
              // virtual: (detail) => {
              //   return toLocaleCurrency(
              //     detail.gross -
              //       this.sumPivot(
              //         detail.insurance_ancillaries[0]?.insurer_participants,
              //         "gross"
              //       )
              //   );
              // },
              // REMOVED: type: "currency",
            },
          ],
        },
        agency: {
          header: "Provvigioni Agenzia",
          fields: [
            {
              label: this.getDictionary("agency_prov_purchase", "book_entry"),
              value: "agency_prov_purchase",
              type: "currency",
            },
            {
              label: this.getDictionary("agency_prov_take", "book_entry"),
              value: "agency_prov_take",
              type: "currency",
            },
            {
              label: this.getDictionary("total_prov", "book_entry"),
              value: "total_prov",
              type: "currency",
              virtual: (detail) => {
                return detail.agency_prov_purchase + detail.agency_prov_take;
              },
            },
          ],
        },
        saler: {
          header: "Provvigioni Collaboratore",
          fields: [
            {
              label: this.getDictionary("saler_prov_purchase", "book_entry"),
              value: "saler_prov_purchase",
              type: "currency",
            },
            {
              label: this.getDictionary("saler_prov_take", "book_entry"),
              value: "saler_prov_take",
              type: "currency",
            },
            {
              label: this.getDictionary("total_prov", "book_entry"),
              value: "total_prov",
              type: "currency",
              virtual: (detail) => {
                return detail.saler_prov_purchase + detail.saler_prov_take;
              },
            },
          ],
        },
        /* documents_not_insurance_policy: {
          header: "Importi Documenti Non Su Polizza",
          fields: [
            {
              label: this.getDictionary("Importo registrazione"),
              value: "",
            },
            {
              label: this.getDictionary("Provvigione Agenzia"),
              value: "",
            },
            {
              label: this.getDictionary("Provvigione Collaboratore"),
              value: "",
            },
          ],
        }, */
      },
      coassFields: {
        coass: {
          header: "Coassicurazioni",
          fields: [
            {
              label: this.getDictionary("Netto"),
              value: "",
              virtual: (detail) => {
                return toLocaleCurrency(
                  this.sumPivot(
                    detail.insurance_ancillaries[0]?.insurer_participants,
                    "net",
                  ),
                );
              },
            },
            {
              label: this.getDictionary("Imposte"),
              value: "",
              virtual: (detail) => {
                return toLocaleCurrency(
                  this.sumPivot(
                    detail.insurance_ancillaries[0]?.insurer_participants,
                    "tax",
                  ),
                );
              },
            },
            {
              label: this.getDictionary("Lordo"),
              value: "",
              virtual: (detail) => {
                return toLocaleCurrency(
                  this.sumPivot(
                    detail.insurance_ancillaries[0]?.insurer_participants,
                    "gross",
                  ),
                );
              },
            },
            {
              label: this.getDictionary("Provvigioni acquisto agente"),
              value: "",
              virtual: (detail) => {
                return toLocaleCurrency(
                  this.sumPivot(
                    detail.insurance_ancillaries[0]?.insurer_participants,
                    "participant_prov_purchase",
                  ),
                );
              },
            },
            {
              label: this.getDictionary("Provvigioni incasso agente"),
              value: "",
              virtual: (detail) => {
                return toLocaleCurrency(
                  this.sumPivot(
                    detail.insurance_ancillaries[0]?.insurer_participants,
                    "participant_prov_take",
                  ),
                );
              },
            },
          ],
        },
      },
      // thClass: "text-right",
      //     thStyle: {
      //       "text-align": "right",
      //     },
      //     tdClass: "text-right",
      coassDetailFields: [
        { key: "compagnia_delegata", label: "Codice Compagnia" },
        { key: "agenzia_delegata", label: "Codice Agenzia" },
        { key: "descrizione", label: "Descrizione" },
        {
          key: "participant_prov_purchase",
          label: "Provv. Acquisto Agente",
          thClass: "text-right",
          tdClass: "text-right",
        },
        {
          key: "participant_prov_take",
          label: "Provv. Incasso Agente",
          thClass: "text-right",
          tdClass: "text-right",
        },
        {
          key: "net",
          label: "Imponibile",
          thClass: "text-right",
          tdClass: "text-right",
        },
        {
          key: "tax",
          label: "Imposte",
          thClass: "text-right",
          tdClass: "text-right",
        },
        {
          key: "gross",
          label: "Totale",
          thClass: "text-right",
          tdClass: "text-right",
        },
      ],
      coassDetails: [],
    };
  },
  methods: {
    toLocaleCurrency,
    toInfoData,
    toLocaleDate,
    fetch() {
      let skipCodes = ["EN", "PR", "COC", "COP"];
      let queryString = `relations/byRegistry/byTreasury/byBreakdown/byBookTag/byInsurer/byBroker/byInsuranceAncillary/byVariousAccounting/byInsurerAccounting/byInsurerParticipant/byBrokerStatement`; // #1167

      return this.fetchShowForm(this.repository, this.resourceId, queryString)
        .then((response) => {
          const data = response.data.data;

          const insurance_policy =
            data.insurance_ancillaries[0]?.insurance_policy;
          if (insurance_policy) {
            if (insurance_policy.sharing_type == 1) {
              this.$set(this, "coassFields", null);
            }
            if (data.insurance_ancillaries[0]?.insurer_participants?.length) {
              this.$set(
                this,
                "coassDetails",
                data.insurance_ancillaries[0].insurer_participants,
              );
            }
          } else {
            this.$set(this, "coassFields", null);
          }
          // sort by entry_time
          data.entry_details.sort((a, b) =>
            a.entry_time.localeCompare(b.entry_time),
          );
          this.details = data;

          this.myEntryDetails = this.buildLinkedList(data.entry_details);

          // check if treasury relation exists card 646
          this.checkTreasuryRelation = data.entry_details.filter(
            (e) => e.treasury,
          );

          // list of negative deferred, if any
          const allNegativeDeferred = this.checkTreasuryRelation.filter(
            (e) => e?.treasury?.code === "SS" && e.gross < 0,
          );

          if (this.checkTreasuryRelation.length !== 0) {
            let skipIds = []; // list if ids to exclude since they have a pivot relation...
            for (const d of allNegativeDeferred) {
              skipIds.push(d.id); // add itself...
              skipIds = skipIds.concat(d.entry_details.map((e) => e.id)); // add the pivot related ones...
            }

            const filteredEntryDetails = data.entry_details.filter(
              (e) =>
                !skipIds.includes(e.id) &&
                !skipCodes.includes(e?.treasury?.code) &&
                (!Array.isArray(e.entry_details) ||
                  e.entry_details.length === 0),
            );

            // Clear old Data
            for (let index of this.entryDetails.keys()) {
              // NEW
              this.$delete(this.entryDetails, index);
            }

            // Set new data
            for (let index of filteredEntryDetails.keys()) {
              // NEW
              this.$set(this.entryDetails, index, filteredEntryDetails[index]);
            }
          }
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
          this.form = {};
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    buildLinkedList(data) {
      const acconto_id = this.$store.state.auth.treasuries.find(
        (t) => t.code === "AC",
      ).id;
      const sospeso_id = this.$store.state.auth.treasuries.find(
        (t) => t.code === "SS",
      ).id;
      const skipCodes = ["EN", "PR", "COC", "COP"];

      // STEP 1: filter out unwanted codes
      const filteredData = data.filter(
        (item) => !skipCodes.includes(item.treasury?.code),
      );

      // STEP 2: separate data
      const positives = [];
      const others = [];

      filteredData.forEach((item) => {
        if (
          [acconto_id, sospeso_id].includes(item.treasury_id) &&
          item.gross > 0
        ) {
          positives.push(item);
        } else if (![acconto_id, sospeso_id].includes(item.treasury_id)) {
          others.push(item);
        }
      });

      // STEP 3: build Acconto/Sospeso linked block
      const linkedBlock = [];
      const usedIds = new Set();

      positives.forEach((pos) => {
        linkedBlock.push({ ...pos, linkType: "parent" });
        usedIds.add(pos.id);

        const linkedNegatives = filteredData.filter(
          (neg) =>
            neg.treasury_id === pos.treasury_id &&
            neg.gross < 0 &&
            Array.isArray(neg.entry_details) &&
            neg.entry_details.length,
        );

        linkedNegatives.forEach((neg) => {
          usedIds.add(neg.id);

          neg.entry_details.forEach((child) => {
            if (
              ![acconto_id, sospeso_id].includes(child.treasury_id) &&
              !skipCodes.includes(child.treasury?.code) &&
              !usedIds.has(child.id)
            ) {
              linkedBlock.push({
                ...child,
                linkType: "child",
                arrow: "↓",
                parentType: pos.treasury.title,
              });
              usedIds.add(child.id);
            }
          });
        });
      });

      // STEP 4: merge → others first, linked block last
      const ordered = [
        ...others.filter((o) => !usedIds.has(o.id)), // prevent duplicates
        ...linkedBlock,
      ];

      return ordered;
    },
    setTab(tab, index) {
      console.log("template.vue - select tab: ", tab.name);
      this.selTab = tab.name;
      this.tabIndex = index;
    },
    onModalShow() {
      if (this.tabIndex < this.tabs.length)
        this.setTab(this.tabs[this.tabIndex], this.tabIndex);
    },
    onModalHidden() {
      this.setTab({ name: "General", text: "Generale" }, 0);
    },
    onOpenDetailsModal(id, caption) {
      console.debug(`onOpenDetailsModal id: ${id} - ${caption}`);
      this.modalResourceId = id;
      this.modalResourceTitle = caption;
      // this.$bvModal.show("detailsModal");
      this.$bvModal.show("modalPolicy");
    },
    totalDeferredOrDeposited(code) {
      return parseFloat(
        this.details.entry_details
          .filter((el) => el?.treasury?.code === code)
          .reduce(function (acc, obj) {
            return acc + obj.gross;
          }, 0)
          .toFixed(2),
      );
    },
    deferredStatus(item) {
      const code = "SS";
      if (
        item.treasury.code === code &&
        this.totalDeferredOrDeposited(code) === item.gross
      )
        return "Totalmente da recuperare";
      if (
        item.treasury.code === code &&
        this.totalDeferredOrDeposited(code) < item.gross &&
        this.totalDeferredOrDeposited(code) !== 0
      ) {
        return "Parzialmente recuperato";
      }
      if (
        item.treasury.code === code &&
        this.totalDeferredOrDeposited(code) === 0
      )
        return "Completamente recuperato";
    },
    depositedStatus(item) {
      const code = "AC";
      if (
        item.treasury.code === code &&
        this.totalDeferredOrDeposited(code) === item.gross
      )
        return "Totalmente da recuperare";
      if (
        item.treasury.code === code &&
        this.totalDeferredOrDeposited(code) < item.gross &&
        this.totalDeferredOrDeposited(code) !== 0
      ) {
        return "Parzialmente recuperato";
      }
      if (
        item.treasury.code === code &&
        this.totalDeferredOrDeposited(code) === 0
      )
        return "Completamente recuperato";
    },
    sumPivot(array, field) {
      let initialValue = 0;
      let sum = array.reduce(function (previousValue, currentValue) {
        return previousValue + currentValue.pivot[field];
      }, initialValue);
      return sum;
    },
  },
  computed: {
    selTab: {
      set(value) {
        this.selected = value;
      },
      get() {
        return this.selected;
      },
    },
    computeModalTitle() {
      return `Dettagli - Numero Polizza: ${this.modalResourceTitle}`;
    },
    agencyHasFee() {
      return this.$store.state.auth.use_fee === "Y" ? true : false;
    },
    isDelegaNostra() {
      let type = 0;
      return (
        this.details.insurance_ancillaries[0]?.insurance_policy.sharing_type
          .value === type
      );
    },
  },
  beforeMount() {
    this.isLoading = true;
    this.fetch();
    if (this.agencyHasFee) {
      const feeCard = {
        header: "Diritti",
        fields: [
          {
            label: this.getDictionary("fee_net", "book_entry"),
            value: "fee_net",
            type: "currency",
          },
          {
            label: this.getDictionary("fee_tax", "book_entry"),
            value: "fee_tax",
            type: "currency",
          },
          {
            label: this.getDictionary("gross", "book_entry"),
            value: "fee_gross",
            type: "currency",
          },
        ],
      };
      this.$set(this.detailFields, "fee", feeCard);
      const salerFeeTakeField = {
        label: this.getDictionary("saler_fee_take", "book_entry"),
        value: "saler_fee_take",
        type: "currency",
      };
      this.detailFields.saler.fields.push(salerFeeTakeField);
    }
  },
};
</script>

<style>
tr:has(.child-row) td {
  padding-block: 0.5rem;
  font-variant-emoji: text;
  font-style: italic;
}
</style>

<style scoped lang="scss">
.card {
  border: none;
}

.col-md-4.border-bottom {
  text-transform: uppercase;
  color: rgb(63, 60, 60);
  font-size: larger;
}

.badge-closed {
  font-size: var(--font-size-xs);
  line-height: 19px;
  margin: 4px 0 0;
  max-width: max-content;
  padding: 2px 8px 3px 10px;
  border-radius: var(--radius-pill);
  color: black;
  background: #99ff99;
}

.badge-partially-closed {
  font-size: var(--font-size-xs);
  line-height: 19px;
  margin: 4px 0 0;
  max-width: max-content;
  padding: 2px 8px 3px 10px;
  border-radius: var(--radius-pill);
  color: black;
  background: #ffff99;
}

.badge-open {
  font-size: var(--font-size-xs);
  line-height: 19px;
  margin: 4px 0 0;
  max-width: max-content;
  padding: 2px 8px 3px 10px;
  border-radius: var(--radius-pill);
  color: black;
  background: #ff9999;
}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
[data-type="book-entry-general"] {
  grid-template-columns: repeat(12, 1fr);
  .custom-grid-wrapper {
    grid-template-columns: 235px 1fr;
  }
  [data-title="book_entry"] {
    grid-area: 1 / 1 / 2 / 5;
  }
  [data-title="insurance_policy"] {
    grid-area: 1 / 5 / 2 / 9;
  }
  [data-title="registry"] {
    grid-area: 1 / 9 / 2 / 13;
  }
  [data-title="book_entry_premium"] {
    grid-area: 2 / 1 / 3 / 5;
  }
  [data-title="agency"] {
    grid-area: 2 / 5 / 3 / 9;
  }
  [data-title="saler"] {
    grid-area: 2 / 9 / 3 / 13;
  }
  [data-title="fee"] {
    grid-area: 2 / 10 / 3 / 13;
  }
  &:has([data-title="fee"]) {
    [data-title="book_entry_premium"] {
      grid-area: 2 / 1 / 3 / 4;
    }
    [data-title="agency"] {
      grid-area: 2 / 4 / 3 / 7;
    }
    [data-title="saler"] {
      grid-area: 2 / 7 / 3 / 10;
    }
  }
  [data-title="forme_di_pagamento"] {
    grid-area: 3 / 1 / 4 / 13;
  }
  [data-title="coass"] {
    grid-area: 4 / 1 / 5 / 5;
  }
  [data-title="coass_detail"] {
    grid-area: 4 / 5 / 5 / 13;
  }
  /* [data-title="documents_not_insurance_policy"] {
    grid-area: 2 / 10 / 3 / 13;
  } */
}

/* Medium screens: 2 cards per row */
@media (max-width: 1469px) {
  [data-type="book-entry-general"] {
    grid-template-columns: repeat(6, 1fr);
    .custom-grid-wrapper {
      grid-template-columns: 180px 1fr;
    }
    [data-title="book_entry"] {
      grid-area: 1 / 1 / 2 / 4;
    }
    [data-title="insurance_policy"] {
      grid-area: 1 / 4 / 2 / 7;
    }
    [data-title="registry"] {
      grid-area: 2 / 1 / 3 / 4;
    }
    [data-title="book_entry_premium"] {
      grid-area: 2 / 4 / 3 / 7;
    }
    [data-title="agency"] {
      grid-area: 3 / 1 / 4 / 4;
    }
    [data-title="saler"] {
      grid-area: 3 / 4 / 4 / 7;
    }
    [data-title="forme_di_pagamento"] {
      grid-area: 4 / 1 / 5 / 7;
    }
    [data-title="fee"] {
      grid-area: 5 / 4 / 6 / 7;
    }
    [data-title="coass"] {
      grid-area: 6 / 1 / 7 / 4;
    }
    [data-title="coass_detail"] {
      grid-area: 6 / 4 / 7 / 7;
    }
    &:not(:has([data-title="fee"])) {
      [data-title="coass"] {
        grid-area: 5 / 1 / 6 / 7;
      }
      [data-title="coass_detail"] {
        grid-area: 6 / 1 / 7 / 7;
      }
    }
    /* [data-title="documents_not_insurance_policy"] {
      grid-area: 4 / 1 / 5 / 4;
    } */
    /* &:has([data-title="documents_not_insurance_policy"]) {
      [data-title="forme_di_pagamento"] {
        grid-area: 5 / 1 / 6 / 7;
      }
    } */
  }
}

/* Small screens: single column stack */
@media (max-width: 999px) {
  [data-type="book-entry-general"] {
    grid-template-columns: 1fr;
    .custom-grid-wrapper {
      grid-template-columns: 140px 1fr;
    }
    [data-title="book_entry"],
    [data-title="insurance_policy"],
    [data-title="registry"],
    [data-title="book_entry_premium"],
    [data-title="agency"],
    [data-title="saler"],
    [data-title="fee"],
    [data-title="coass"],
    [data-title="coass_detail"],
    [data-title="forme_di_pagamento"] {
      grid-area: auto;
    }
    // [data-title="documents_not_insurance_policy"] { grid-area: auto; }
  }
}
</style>
